// extracted by mini-css-extract-plugin
export default {"container":"scene_container__5-OmI","logo":"scene_logo__9IgNB","toggle":"scene_toggle__bURkq","img":"scene_img__MqGUR","loader":"scene_loader__Xt0el","rotate":"scene_rotate__RrmaN"};